import { render } from "./Api.vue?vue&type=template&id=5ddef634&scoped=true"
import script from "./Api.vue?vue&type=script&lang=js"
export * from "./Api.vue?vue&type=script&lang=js"

import "./Api.vue?vue&type=style&index=0&id=5ddef634&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddef634"]])

export default __exports__